import moods from '../data/moods.json';

export function getRecommendations(moodKey) {
  if (!moodKey || !moods[moodKey]) {
    return [];
  }
  return moods[moodKey];
}

export function getAllMoods() {
  return Object.keys(moods);
}

export function getMoodLabel(moodKey) {
  const labels = {
    happy: '😊 Happy',
    sad: '😔 Sad',
    stressed: '😤 Stressed',
    tired: '😴 Tired',
    calm: '😌 Calm',
    sick: '🤒 Sick'
  };
  return labels[moodKey] || moodKey;
}
